import React, { useState, useRef, useEffect, useContext } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { useNavigate, Link } from "react-router-dom";

import { Routes, Route } from "react-router-loading";



import logo from "./vmlogo2.png";
import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Authenticator,
  useAuthenticator,
  Button,
  useTheme,
  Image,
  View,
  Card,
  Message
} from "@aws-amplify/ui-react";


import './App.css';

import { useOnClickOutside } from './hooks';

import { useOnClientSignIn } from './hooks';


import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './global';
import { theme } from './theme';
import FocusLock from 'react-focus-lock';

import Dashbar from "./components/Dashbar";

import Menu from './components/Menu';
import Burger from './components/Burger';
import Home from './pages';
import Pricing from './pages/pricing';
import About from './pages/about';
import Contact from './pages/contact';
import Error from './components/Error/Error.js';

import { Amplify } from 'aws-amplify';
import config from './aws-exports';

import { signOut } from 'aws-amplify/auth';
import { getCurrentUser } from 'aws-amplify/auth';
import { fetchAuthSession } from 'aws-amplify/auth';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { fetchDevices } from 'aws-amplify/auth';

import { recordAuthAuditEntry } from './utils/authAudit';


import { ClientContextProvider } from './store/client-context.jsx';


//import { ClientContext } from '../../store/client-context.jsx';



Amplify.configure(config);


export const DefaultImageExample = () => {
  return (
    <Image
        objectFit="initial"
        objectPosition="50% 50%"
        backgroundColor="initial"
        height="50%"
        width="50%"
        opacity="100%"
        src={logo}
        alt=""
    />
  );
};


async function handleSignOut() {
  try {
    await recordAuthAuditEntry('logoff');
    await signOut({ callbackUrl: "/" });
  } catch (error) {
    console.log('error signing out: ', error);
  }
}

/*
async function handleSignIn() {
  try {
  
    const { username, userId, signInDetails } = await getCurrentUser();

    console.log("username", username);
    console.log("user id", userId);
    console.log("sign-in details", signInDetails);

} catch (error) {
  console.log({
    message:
      error.message || 'failure getting session info',
  });
}

}
*/
/*
async function handleSignIn() {
  try {
  
    const session = await fetchAuthSession();

    console.log("id token", session.tokens.idToken);
    console.log("access token", session.tokens.accessToken);
    console.log("sessopm", session);

} catch (error) {
  console.log({
    message:
      error.message || 'failure getting session info',
  });
}


}
*/



async function handleSignIn() {
  try {
  
    //const userAttributes = await fetchUserAttributes();

    const currentUser = await getCurrentUser();

     //console.log("userAttributes.preferred_username=", userAttributes.preferred_username);


    // const { slctdClient, changeClient } = useContext(ClientContext);

    // changeClient ( userAttributes.preferred_username );

    // console.log("slctdClient=", slctdClient);

    
 
    // return ( userAttributes.preferred_username);

    return ( currentUser );

   
     // set context item with user account

     //const { changeClient } = useContext(ClientContext);

     //changeClient ( userAttributes.preffered_username );

} catch (error) {
  console.log({
    message:
      error.message || 'failure getting session info',
  });
}
}

/*
async function handleSignIn() {
  try {
  
    const devices = await fetchDevices();

     console.log("devices", devices);

} catch (error) {
  console.log({
    message:
      error.message || 'failure getting session info',
  });
}
}
*/



const AuthAuditTrail = () => {
  const { authStatus } = useAuthenticator();
  const navigate = useNavigate();
  const hasRecordedLogon = useRef(false);

  useEffect(() => {
    if (authStatus === 'authenticated' && !hasRecordedLogon.current) {
      hasRecordedLogon.current = true;
      recordAuthAuditEntry('logon');
      navigate('/', { replace: true });
    }

    if (authStatus === 'unauthenticated') {
      hasRecordedLogon.current = false;
    }
  }, [authStatus, navigate]);

  return null;
};

const INACTIVITY_TIMEOUT_MS = 10 * 60 * 1000;
const WARNING_TIMEOUT_MS = 60 * 1000;

const AuthStateApp = ({ signOut }) => {

  const [showWarning, setShowWarning] = useState(false);
  const [warningCountdown, setWarningCountdown] = useState(WARNING_TIMEOUT_MS / 1000);
  const inactivityTimerRef = useRef(null);
  const warningTimerRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const isSigningOutRef = useRef(false);

  const stopInactivityTracking = () => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
      inactivityTimerRef.current = null;
    }

    if (warningTimerRef.current) {
      clearTimeout(warningTimerRef.current);
      warningTimerRef.current = null;
    }

    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = null;
    }
  };

  const resetInactivityTracking = () => {
    stopInactivityTracking();
    setShowWarning(false);
    setWarningCountdown(WARNING_TIMEOUT_MS / 1000);

    inactivityTimerRef.current = setTimeout(() => {
      setShowWarning(true);
      setWarningCountdown(WARNING_TIMEOUT_MS / 1000);

      countdownIntervalRef.current = setInterval(() => {
        setWarningCountdown((currentValue) => {
          if (currentValue <= 1) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
            return 0;
          }

          return currentValue - 1;
        });
      }, 1000);

      warningTimerRef.current = setTimeout(async () => {
        stopInactivityTracking();
        if (!isSigningOutRef.current) {
          isSigningOutRef.current = true;
          await handleSignOut();
        }
      }, WARNING_TIMEOUT_MS);
    }, INACTIVITY_TIMEOUT_MS);
  };

  const cancelWarning = () => {
    stopInactivityTracking();
    setShowWarning(false);
    setWarningCountdown(WARNING_TIMEOUT_MS / 1000);
    resetInactivityTracking();
  };

  useEffect(() => {
    resetInactivityTracking();

    const activityEvents = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll', 'click'];
    const handleActivity = () => {
      resetInactivityTracking();
    };

    activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, handleActivity);
    });

    return () => {
      activityEvents.forEach((eventName) => {
        window.removeEventListener(eventName, handleActivity);
      });
      stopInactivityTracking();
    };
  }, []);

  const components = {
    Header() {
      const { tokens } = useTheme();

      const [showMessage, setShowMessage] = useState(false);
      const [messageContent, setMessageContent] = useState('');

      const handleClick = () => {
        setMessageContent("Virtualis Medical Systems and Simpelsoft Medical Systems are DBA's for Robert Klajbor. He has provided medical software to physicians in Puerto Rico for over thirty years. Virtualis is used for cloud-used solutions such as it's EHR and pathology system interface with hospital medical records. Simpelsoft is used for client-server solutions for patholgy/cytology and 837/835 medical billing/accounting. For further information please contact robert.klajbor@virtualismed.com.");
        setShowMessage(true);
      };
  
      return (
        <View textAlign="center" padding={tokens.space.large} >
          <DefaultImageExample/>
          <br/>
          <div>
            <Button fontWeight="normal" size="small" onClick={handleClick}>About</Button>

          {showMessage && (
            <View>
            <Message colorTheme="info" isDismissible={true}onDismiss={() => {setShowMessage(false);}}>
              {messageContent}
            </Message>
            </View>
          )}
          </div>
          <br/>
        </View>
      );
    },
    SignIn: {
     
      Footer() {
        const { toForgotPassword } = useAuthenticator();
        return (
          <View textAlign="center" >
            <Button fontWeight="normal" onClick={toForgotPassword} size="small">
              Forgot Password???
            </Button>
          </View>
        );
      },
    },
  };

  
  const [open, setOpen] = useState(false);
  const node = useRef();
  const menuId = "main-menu";

 
  const [clientUser, setClientUser] = useState('');

  const [isFetching, casesIsFetching] = useState(false);

  useEffect(() => {


    async function fetchUser() {

      casesIsFetching(true);


      try {
  
        const userAttributes = await fetchUserAttributes();
    
        casesIsFetching(false);

        setClientUser(userAttributes.preferred_username);

      } catch (error) {
        console.log({
          message:
            error.message || 'failure getting session info',
        });
      }

   

    } 

    fetchUser();

  }, []);
  
  
  useOnClickOutside(node, () => setOpen(false)); 



  //const navigate = useNavigate();


 
      
  
  return (
    <Authenticator components={components} hideSignUp >
    <AuthAuditTrail />
    <div> 
    { !isFetching && (
    <ClientContextProvider  >
      <ThemeProvider theme={theme}>
      <div className="App" >
        <div ref={node}>
            <FocusLock disabled={!open}> 
              <Burger open={open} setOpen={setOpen} aria-controls={menuId} />
              <Menu open={open} setOpen={setOpen} id={menuId} /> 
              <Dashbar open={open} setOpen={setOpen} id={menuId} /> 
            </FocusLock>
        </div>
        <Routes>
          <Route path="/" exact element={<Home  />} />
          <Route path="/about" element={<About clientUser={clientUser} />  } />
          <Route path="/pricing" element={<Pricing  />  }   />
          <Route path="/contact" element={<Contact  />} />
        </Routes>
      </div>

      {showWarning && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <View
            style={{
              width: 'min(420px, calc(100vw - 32px))',
              padding: '24px',
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
            }}
          >
            <Message colorTheme="warning" heading="Session timeout warning">
              You have been inactive for 10 minutes. You will be signed out automatically in {warningCountdown} seconds.
            </Message>
            <View textAlign="center" marginTop="16px">
              <Button onClick={cancelWarning}>Cancel Logout</Button>
            </View>
          </View>
        </div>
      )}
      
       <Button onClick={handleSignOut}>Sign Out</Button>
      </ThemeProvider>
    </ClientContextProvider> 
    )}
    </div> 
    </Authenticator>
    );
  }
  
  export default AuthStateApp;
  


  
